<dx-box
  direction="row"
  class="row-box"
  [height]="60"
  *ngIf="result && tabType === 'instrument'"
>
  <dxi-item
    [ratio]="1"
    [baseSize]="'auto'"
  >
    <dx-button
      stylingMode="text"
      id="leftButt"
      [width]="40"
      [height]="55"
      type="normal"
      [disabled]="leftButt"
      (onClick)="tipeLeft()"
      icon="chevronleft"
    >
    </dx-button>
  </dxi-item>
  <dxi-item
    [ratio]="50"
    [baseSize]="'auto'"
  >
    <dx-box
      direction="row"
      class="row-box"
    >
      <dxi-item
        [ratio]="1"
        [baseSize]="'auto'"
        [width]="boxWidth"
        class="tile"
        (click)="taleClick('All')"
      >
        Expiration dates<br/>
        Show all
      </dxi-item>
      <dxi-item
        [ratio]="1"
        [baseSize]="'auto'"
        [width]="boxWidth"
        *ngFor="let tile of actTiles, let i=index"
        class="tile"
        (click)="taleClick(tile.dateR)"
      >
        {{tile.date}}<br/>{{tile.iv | number:'.2'}}<br/>{{tile.iv_eod | number:'.2'}}
      </dxi-item>
    </dx-box>
  </dxi-item>
  <dxi-item
    [ratio]="1"
    [baseSize]="'auto'"
  >
    <dx-button
      stylingMode="text"
      id="rightButt"
      [width]="40"
      [height]="55"
      type="normal"
      [disabled]="rightButt"
      (onClick)="tipeRight()"
      icon="chevronnext"
    >
    </dx-button>
  </dxi-item>
</dx-box>

<div class="service-toolbar" [style.grid-template-columns]="'auto 1fr'">

  <iv-live-option-monitor-filters
    (downloadCSVClick)="popupCredit = true"
    (emitSubmit)="onSubmit()"
    (expirationSelected)="strikeSkewExpiration($event)"
    [expirationsLoaded]="{flag: expirations.length > 0, exp: expirations}"
    style="justify-self: end;"
  ></iv-live-option-monitor-filters>

  <div style="display: flex; justify-content: flex-end; margin-right: 15px;">
    <iv-live-image-button
      statistic
      statisticElementName="Click Option Monitor column setting"
      (buttonClicked)="onEditColumnsClick()"
      (mouseover)="getSettingTip()"
      [tip]="'Column settings'"
      id="editServiceColumnsButton"
      style="margin-left: 10px; overflow: visible;"
    >
      <span class="material-icons">&#xE8B8;</span>
    </iv-live-image-button>

    <div style="flex-grow: 2"></div>

    <iv-live-image-button
      *ngIf="tabType === 'future'"
      (buttonClicked)="onFutCurveClick()"
      statistic
      statisticElementName="Click Option Monitor futures curve"
      [tip]="'Futures Curve'"
      class="with-caption"
      style="margin-left: 13px; overflow: visible;"
    >
      <img
        src="../../../../iv-live/assets/icons/fut-curve.png"
      >
      <span
        class="image-label"
        style="white-space: nowrap; margin-left: 3px; margin-right: 2px;"
      >
        Futures Curve
      </span>
    </iv-live-image-button>

    <iv-live-image-button
      *ngIf="tabType === 'future'"
      (buttonClicked)="onFutCurveClick()"
      statistic
      statisticElementName="Click Option Monitor futures curve"
      [tip]="'Futures Curve'"
      class="without-caption"
      style="margin-left: 13px; overflow: visible;"
    >
      <img
        src="../../../../iv-live/assets/icons/fut-curve.png"
      >
    </iv-live-image-button>

    <iv-live-image-button
      *ngIf="tabType === 'instrument'"
      (buttonClicked)="onEODChartsClick()"
      statistic
      [statisticElementName]="'Option monitor eod charts click'"
      class="with-caption"
      id="eodChartsButtons"
      style="margin-left: 13px; overflow: visible;"
    >
      <img
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAIAAABvFaqvAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAZFJREFUeNpiFNjc8eH3DwbKgAArBxMxpnAxsybIG+BRADSEiRgLLYVkgEiYjQuPGqIMchZTApOKeNSwEDQF6JAFDy+o8wrf/PyWIhe9/fXt1heQERCSIq8RA6Be+x9YjyYx4e6Jwks7sepR4BKYb+zvIKIAZB9488Dx8EJ8LipQtgiQ1MAqVa9pDzEFi4sY1zciizZoOtRr2PtLqW94fgMz7UEsADoE6BwCYQSMJiCZIGdgwC+B7lIVC6BZQCOQTcFp0INvHxY8ApnVr+eOFjr5yuZARuP1g8TGGkQpMCyAgQUXBIYxVucAATNDuAOu7MPIyAg0yENc5eG3j9///a5Ut4GETuCJlS9+fiEhZTdcPyDPxQ8MKaBD4IKJZzde+PgCwg6T0d776j4wxSIM8pVUw2rWumfXlbmFzAWl2ZiYgRoWPLr49vc3uGJgVDiLKgLN3fL8FtSgzc9v4XIXRAqoGVONpZAsMN8cf/vk8fdPLJRki97bxyH+ojSvwU2hZqYdzgYBkzwx6vCkD0iRABBgAChinJn0/f3yAAAAAElFTkSuQmCC"
      >
      <span
        class="image-label"
        style="white-space: nowrap; margin-left: 3px; margin-right: 2px;"
      >
        EOD Charts
      </span>
    </iv-live-image-button>

    <iv-live-image-button
      *ngIf="tabType === 'instrument'"
      (buttonClicked)="onEODChartsClick()"
      statistic
      statisticElementName="Click Option Monitor eod charts"
      [tip]="'EOD Charts'"
      class="without-caption"
      style="margin-left: 13px; overflow: visible;"
    >
      <img
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAIAAABvFaqvAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAZFJREFUeNpiFNjc8eH3DwbKgAArBxMxpnAxsybIG+BRADSEiRgLLYVkgEiYjQuPGqIMchZTApOKeNSwEDQF6JAFDy+o8wrf/PyWIhe9/fXt1heQERCSIq8RA6Be+x9YjyYx4e6Jwks7sepR4BKYb+zvIKIAZB9488Dx8EJ8LipQtgiQ1MAqVa9pDzEFi4sY1zciizZoOtRr2PtLqW94fgMz7UEsADoE6BwCYQSMJiCZIGdgwC+B7lIVC6BZQCOQTcFp0INvHxY8ApnVr+eOFjr5yuZARuP1g8TGGkQpMCyAgQUXBIYxVucAATNDuAOu7MPIyAg0yENc5eG3j9///a5Ut4GETuCJlS9+fiEhZTdcPyDPxQ8MKaBD4IKJZzde+PgCwg6T0d776j4wxSIM8pVUw2rWumfXlbmFzAWl2ZiYgRoWPLr49vc3uGJgVDiLKgLN3fL8FtSgzc9v4XIXRAqoGVONpZAsMN8cf/vk8fdPLJRki97bxyH+ojSvwU2hZqYdzgYBkzwx6vCkD0iRABBgAChinJn0/f3yAAAAAElFTkSuQmCC"
      >
    </iv-live-image-button>


    <iv-live-image-button
      (buttonClicked)="onSurfaceClick()"
      statistic
      statisticElementName="Click Option Monitor volatility surface"
      class="with-caption image-button-options-chain"
      id="surfaceButtons"
      style="margin-left: 13px; overflow: visible;"
    >
      <img src="data:image/png;base64,
iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAIAAABvFaqvAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAzxJREFUeNqcVV1IU2EY3tzZ5jb343SbP5tONpyp09LCeWFaGiaF1U0iBBbU9bzoal0kQRIhmQRBYJR1YQZFGUEI/pCSCzH/ZqkznTpzmT9zOpeas0fPmPOcWdHLx8c57/d+z/uc532/7zAlb245N34yAkzFE2Ge8rgY/2wSdihBQYHxWOygoRfjDhq1WbZV57H2OsoqQIi/ZlPzJdgPFGC5f63zWey8SHXbnI0SFvIHCGx4lHlmvNCoFynuj3XBY/rcUj81cP1ALj04OKPzypR8WcIRSUyjY6S06wU8NWkna22fxt2LGKUqPZ0UQRGiXGsoi0sHf2S+Y+0k/ZUp+WPuxcaZYfKVJNXWHgwIENVphWejk+we11uH1eL6Pu1ZJpeQX8Bi3xxu9+9p/jFOJ+UDQobDkpirA02za+5YntC/rBfJi6MSIQ1kDsxPJ+UTG1ywBpTAaDlXYNLlkNJQRASpZKEMpPYAocAYA65ZSvQ1XQ42YAQtCKV8BFlm5ESZ5KFhkCNJGAlnYlgE5rtfP+7XHBSlWIySPPQbGEk4PDToxpa3xzljXZnXCKTgeEWdwWAyLTSypEG4ElVq3WTfLqPqUbNfCIgtYHEgkLH/Xb3dUq7JMoTHghpdqQRBOMrt0whcZBw+JcggVYIFEsIPOPPidGXycXwIJeZoZPw5c4MPCHToMqeK5OYFe6CugEMr1GYUYya5GDVZl7pf4wz7xM6VxdMl0IZJq6wfAj3oDNNgc3G0zrRTSsBVjXa+mhnaLT8YCQgOFjCgC1xSNm9h3UPpKdJwSkAN9Z3wLFV8adtzRKB5ulhxQqEhVSe9kEbK2YajYyEfKuuXZheIApwtVenF8iKF9l56UeucrWNuEqBr3k1/mS6rM0531tOvw+0+CkTRCSMe2noa7INcFnFBqccGIZsbxxdvbnm9O9fAjaH3z6YtdKYhFJTHE73kK5gi86moxExJDHgJCe7t1AJc5E+n+oM2J5PxsoKOEnhDteaUiQkuWilbqizoeIK+U/HFw8vzfUuO1c2NPUD7ofgNV1W5xnCo5UHvksP/p8mOUOGh1+kYWZnfBtI01YD8c/sg478MJFR8Ubfz228BBgCoiYBqo/4YOgAAAABJRU5ErkJggg==
">
      <span
        class="image-label"
        style="white-space: nowrap; margin-left: 3px;"
      >
        Volatility surface
      </span>
    </iv-live-image-button>

    <iv-live-image-button
      (buttonClicked)="onSurfaceClick()"
      statistic
      statisticElementName="Click Option Monitor volatility surface"
      [tip]="'Volatility surface'"
      class="without-caption image-button-options-chain"
      style="margin-left: 10px; overflow: visible;"
    >
      <img
        src="data:image/png;base64,
iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAIAAABvFaqvAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAzxJREFUeNqcVV1IU2EY3tzZ5jb343SbP5tONpyp09LCeWFaGiaF1U0iBBbU9bzoal0kQRIhmQRBYJR1YQZFGUEI/pCSCzH/ZqkznTpzmT9zOpeas0fPmPOcWdHLx8c57/d+z/uc532/7zAlb245N34yAkzFE2Ge8rgY/2wSdihBQYHxWOygoRfjDhq1WbZV57H2OsoqQIi/ZlPzJdgPFGC5f63zWey8SHXbnI0SFvIHCGx4lHlmvNCoFynuj3XBY/rcUj81cP1ALj04OKPzypR8WcIRSUyjY6S06wU8NWkna22fxt2LGKUqPZ0UQRGiXGsoi0sHf2S+Y+0k/ZUp+WPuxcaZYfKVJNXWHgwIENVphWejk+we11uH1eL6Pu1ZJpeQX8Bi3xxu9+9p/jFOJ+UDQobDkpirA02za+5YntC/rBfJi6MSIQ1kDsxPJ+UTG1ywBpTAaDlXYNLlkNJQRASpZKEMpPYAocAYA65ZSvQ1XQ42YAQtCKV8BFlm5ESZ5KFhkCNJGAlnYlgE5rtfP+7XHBSlWIySPPQbGEk4PDToxpa3xzljXZnXCKTgeEWdwWAyLTSypEG4ElVq3WTfLqPqUbNfCIgtYHEgkLH/Xb3dUq7JMoTHghpdqQRBOMrt0whcZBw+JcggVYIFEsIPOPPidGXycXwIJeZoZPw5c4MPCHToMqeK5OYFe6CugEMr1GYUYya5GDVZl7pf4wz7xM6VxdMl0IZJq6wfAj3oDNNgc3G0zrRTSsBVjXa+mhnaLT8YCQgOFjCgC1xSNm9h3UPpKdJwSkAN9Z3wLFV8adtzRKB5ulhxQqEhVSe9kEbK2YajYyEfKuuXZheIApwtVenF8iKF9l56UeucrWNuEqBr3k1/mS6rM0531tOvw+0+CkTRCSMe2noa7INcFnFBqccGIZsbxxdvbnm9O9fAjaH3z6YtdKYhFJTHE73kK5gi86moxExJDHgJCe7t1AJc5E+n+oM2J5PxsoKOEnhDteaUiQkuWilbqizoeIK+U/HFw8vzfUuO1c2NPUD7ofgNV1W5xnCo5UHvksP/p8mOUOGh1+kYWZnfBtI01YD8c/sg478MJFR8Ubfz228BBgCoiYBqo/4YOgAAAABJRU5ErkJggg==
"
      >
    </iv-live-image-button>

    <iv-live-image-button
      *ngIf="hasOptions && !hideCharts"
      (buttonClicked)="volatilityTablePopupVisible = true"
      statistic
      statisticElementName="Click summary line volatility table"
      class="with-caption image-button-options-chain"
      style="margin-left: 13px; overflow: visible;"
    >
      <img src="iv-live/assets/icons/ivx-table.svg" width="24px">
      <span
        class="image-label"
        style="white-space: nowrap; margin-left: 3px;"
      >
        Volatility Table
      </span>
    </iv-live-image-button>

    <iv-live-image-button
      *ngIf="hasOptions && !hideCharts"
      (buttonClicked)="volatilityTablePopupVisible = true"
      statistic
      statisticElementName="Click summary line volatility table"
      [tip]="'Volatility Table'"
      class="without-caption image-button-options-chain"
      style="margin-left: 10px; overflow: visible;"
    >
      <img src="iv-live/assets/icons/ivx-table.svg" width="24px">
    </iv-live-image-button>
  </div>
</div>

<div
  #serviceResult
  class="service-result"
>
  <iv-live-option-monitor-table
    (expirationButtonClicked)="onExpirationButtonClick($event)"
    (showCalculatorMessage)="showMessage($event)"
    (strikeButtonClicked)="onStrikeButtonClick($event)"
    (setGridHeaderTitles)="setGridHeaderTitles($event)"
    [columns]="gridColumns"
    [data]="result"
    [serviceResultElementRef]="serviceResult"
    [emptyMessage]="'No options found'"
    [instrument]="instrument"
    [scrollBuffer]="scrollBuffer"
    [visibleColumns]="gridVisibleColumns"
  >
  </iv-live-option-monitor-table>

  <ngx-spinner
    [fullScreen]="false"
    bdColor="rgba(51,51,51,0.1)"
    bdOpacity=0.5
    color="#fff"
    name=optionMonitor
    size="medium"
    type="ball-spin-clockwise"
  >
    <p style="color: white"></p>
  </ngx-spinner>
</div>

<dx-popup
  [(visible)]="downloadCSVPopupVisible"
  [class]="downloadSCVClass"
  [closeOnOutsideClick]="true"
  [dragEnabled]="false"
  [height]="130"
  [position]="downloadSCVPopupPosition"
  [showCloseButton]="false"
  [showTitle]="false"
  [width]="240"
  title="popup"
>
  <div *dxTemplate="let data of 'content'">
    <span class="dx-popup-custom-title">Choose expiration</span>
    <iv-live-dropdown
      [(selectedData)]="expiration"
      [cssClass]="'textfield filter-expiration'"
      [data]="expirations"
      [hasMultipleChoice]="true"
      [label]="'Expirations'"
      [type]="'expirations'"
      [valueAttribute]="'value'"
    >
    </iv-live-dropdown>

    <div class="buttons-container">
      <div
        (click)="onDownloadClick()"
        statistic
        statisticElementName="Click tab download csv"
        class="iv-flat-button button apply"
      >
        <span>Download</span>
      </div>
      <div
        (click)="onPopupCancel()"
        statistic
        statisticElementName="Click cancel tab download csv"
        class="iv-flat-button iv-flat-button-alert button cancel"
      >
        <span>Cancel</span>
      </div>
    </div>


  </div>
</dx-popup>

<dx-popup
  [(visible)]="strikeSkewChartVisible"
  [height]="'50%'"
  [shading]="false"
  [showCloseButton]="true"
  [showTitle]="true"
  [width]="'50%'"
  class="strike-skew-chart light"
  title="Strike Skew {{instrument.symbol}} {{chartExpiration}}"
>
  <div *dxTemplate="let data of 'content'">
    <iv-live-strike-skew-chart
      *ngIf="strikeSkewChartVisible"
      [expirationDate]="chartExpiration"
      [futureExpirationDate]="futExpDate"
      [instrument]="instrument"
      [mode]="mode"
      [tabType]="currentTab.type"
      [forwardPrice]="getForwardPrice(chartExpiration)"
      [forwardPriceEod]="getForwardPriceEod(chartExpiration)"
      style="height: 96%;"
    ></iv-live-strike-skew-chart>
    <div class="ivol-view">Chart by IVolatility.com</div>
  </div>
</dx-popup>

<dx-popup
  [(visible)]="timeSkewChartVisible"
  [height]="'50%'"
  [shading]="false"
  [showCloseButton]="true"
  [showTitle]="true"
  [width]="'50%'"
  class="time-skew-chart light"
  title="Time Skew {{instrument.symbol}} {{chartStrike | number:'1.0-3'}}"
>
  <div *dxTemplate="let data of 'content'">
    <iv-live-time-skew-chart
      *ngIf="timeSkewChartVisible"
      [instrument]="instrument"
      [futureExpirationDate]="futExpDate"
      [mode]="mode"
      [strike]="chartStrike"
      [tabType]="currentTab.type"
      style="height: 96%;"
    ></iv-live-time-skew-chart>
    <div class="ivol-view">Chart by IVolatility.com</div>
  </div>
</dx-popup>

<dx-popup
  [(visible)]="chartFutCurveVisible"
  [height]="'50%'"
  [shading]="false"
  [showCloseButton]="true"
  [showTitle]="true"
  [width]="'50%'"
  class="chart-window"
  title="Futures Curve"
>
  <div *dxTemplate="let data of 'content'">
    <iv-live-fut-curve
      [instrument]="instrument"
    ></iv-live-fut-curve>
    <div class="ivol-view">Chart by IVolatility.com</div>
  </div>
</dx-popup>

<dx-popup
  [(visible)]="chartVisible"
  [height]="'50%'"
  [shading]="false"
  [showCloseButton]="true"
  [showTitle]="true"
  [width]="'50%'"
  class="chart-window"
  title="EOD Charts"
>
  <div *dxTemplate="let data of 'content'">
    <iv-live-charts-window
      [instrument]="instrument"
      style="height: 96%;"
    ></iv-live-charts-window>
    <div class="ivol-view ivol-watermark-under-chart">Chart by IVolatility.com</div>
  </div>
</dx-popup>

<dx-popup
  [(visible)]="surfaceVisible"
  [closeOnOutsideClick]="true"
  [dragEnabled]="true"
  [height]="650"
  [position]="'top'"
  [shading]="false"
  [showTitle]="true"
  [width]="1100"
  class="chart-window"
  title="Volatility Surface"
>
  <div *dxTemplate="let data of 'content'">
    <iv-live-skew-surface
      [instrument]="instrument"
      [tabType]="tabType"
      [mode]="mode"
      style="height: 96%;"
    ></iv-live-skew-surface>
    <div class="ivol-view">Chart by IVolatility.com</div>
  </div>
</dx-popup>

<dx-popup
  #columnSettingsPopup
  [(visible)]="editColumnsPopupVisible"
  [class]="editColumnsClass"
  [closeOnOutsideClick]="true"
  [dragEnabled]="false"
  [height]="editColumnsPopupHeight"
  [position]="editColumnsPopupPosition"
  [shading]="false"
  [showCloseButton]="true"
  [showTitle]="true"
  [title]="'Column Settings'"
  [width]="355"
>
  <div *dxTemplate="let data of 'content'">
    <iv-live-columns-chooser
      (columnSwitch)="onColumnSwitch($event)"
      (saveDefault)="saveDefault($event)"
      [columns]="settingColumns"
      [regionId]="instrument.regionId"
      [visibleColumns]="visibleColumns"
      (restoreDefaultColumns)="setDefaultConfigClick()"
      [needRestoreDefaultColumns]="true"
    ></iv-live-columns-chooser>
  </div>
</dx-popup>

<dx-popup
  [(visible)]="calculatorsPopupPopupVisible"
  [closeOnOutsideClick]="false"
  [dragEnabled]="true"
  [height]="isFutures ? 365 : 415"
  [shading]="false"
  [showCloseButton]="false"
  [showTitle]="true"
  [width]="900"
  class="create-popup"
  titleTemplate="title"

>
  <div
    *dxTemplate="let data of 'title'"
    [style.backgroundColor]="themeColor === themeColorEnum.DARK ? '' : '#f1f2f7'"
    style="display: flex; padding: 0; border-bottom: none; height: 40px;"
  >
    <div
      *ngIf="tabType === tabTypeEnum.OPTION_CHAIN"
      class="calculator-panel"
      style=" margin-right: 5px; margin-left: 5px;  padding: 0; border-bottom: 1px solid #8B93A6"
    >
      <span class="calculator-name">Options Calculator</span>

      <div
        class="with-tip"
        style="margin-right: 150px; margin-top: 6px;"
      >
        <a
          statistic
          statisticElementName="Click watch Option Monitor tutorial"
          href="https://youtu.be/IP0MqazcVnY"
          target="_blank"
        >
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAACIklEQVRIidWVz2sTQRTHP7MbqQpeKkWjUaFHA/5AJclJT55ELdEcPHqSgggWFEHMBIr2oB56Kf0LxMVgvfQfUGoMlGoCOYqkNSlSDXixLc0+D0maTTObXb31Cwszs9/3/c5785iB3Q4VyHAcm0glhagEIkfbqytYFCmxgNbu/xnMTw+x3hhH5CFwyIe1iqgpXJkhozfDG+R1DJgDzg3anQclLK4xpr8FG+QnT8BWATgcUryDOk2SZHTV32B+eog/v4rAKYPAF1BvW0MZA04bOEttk+1yWT2/1xvjRnHFK4Y5TzqbI53NsRa9ALw2GJwlwh1zBo5jY1e+03+gW1iMIMQQ3rUSsK6yd0+NjY0fQGQHv06ZWKe7uhlEKimDOEADlwzwAhgFRrHc21x51AC+GvhR4iQ7E2+JkgYywAgwi3C5Pd+kac3hvNwHRI0RymxgJveiiahb3HzyHvu3Bg74GBwxGYTBU25k8+RzE8CDMAFdA1G1EPz9vNH3QZ4PZAnbWp4OUAWQIIOJELcXKBY6w24GZfcjsBoQ+qH9DUKNMsV+A61dRE0NCKxS5iLNk5eAZV+W8Mx7w/YesiszCJ99Qg9yxopjVeLAsA9nkZ/RWe9Cf0UdfRybAuHa1osadiTJ9cc92fW3aUZXaZIElv5BfBFI7BQ3G3hNFPeA+gDhOsJd1qIp0nrFRAhuOq0t4iSxVQJXjrW2pZZBFSi5n4KezN2Pvw7WpK5LkS4RAAAAAElFTkSuQmCC"
          />
        </a>
        <span
          class="tip"
          style="text-align: center; padding: 5px; width: 140px;"
        >
        Watch tutorial
      </span>
      </div>

      <div
        (click)="switchModeOptions()"
        [class.switcherDisabled]="this.regionIdOptions == 2 || this.regionIdOptions == 3 || this.regionIdOptions == 4"
        class="chart-switcher"
      >
        <div
          *ngIf="isRt && this.regionIdOptions === 1"
          [class.active]="!isEODOptions"
          [class.disable]="this.regionIdOptions == 2 || this.regionIdOptions == 3 || this.regionIdOptions == 4"
          style="font-weight:normal; width: 36px; font-size: 12px"
        >RT
        </div>
        <div
          *ngIf="isDelayed && this.regionIdOptions === 1"
          [class.active]="!isEODOptions"
          [class.disable]="this.regionIdOptions == 2 || this.regionIdOptions == 3 || this.regionIdOptions == 4"
          style="font-weight:normal; width: 64px ; font-size: 12px;padding-left: 5px "
        >DELAYED
        </div>
        <div
          *ngIf="isRt && this.regionIdOptions !== 1"
          [class.active]="!isEODOptions"
          [class.disable]="this.regionIdOptions == 2 || this.regionIdOptions == 3 || this.regionIdOptions == 4"
          style="font-weight:normal; width: 36px; font-size: 12px"
          title="This mode is only available for the USA stocks"
        >RT
        </div>
        <div
          *ngIf="isDelayed && this.regionIdOptions !== 1"
          [class.active]="!isEODOptions"
          [class.disable]="this.regionIdOptions == 2 || this.regionIdOptions == 3 || this.regionIdOptions == 4"
          style="font-weight:normal; width: 64px ; font-size: 12px;padding-left: 5px "
          title="This mode is only available for the USA stocks"
        >DELAYED
        </div>
        <div
          [class.active]="isEODOptions"
          style="font-weight:normal; width: 36px ; font-size: 12px; text-align: center; padding-left: 5px"
        >EOD
        </div>
      </div>

      <iv-live-image-button
        (buttonClicked)="closeCalculatorWindow()"
        statistic
        statisticElementName="Click Option Monitor close calculator window"
      >
        <div class='square-content'>
          <div>
            <span
              class="material-icons"
              style="color: #8B93A6;"
            >&#xE5CD;</span>
          </div>
        </div>
      </iv-live-image-button>
    </div>

    <div
      *ngIf="tabType === tabTypeEnum.FUTURES_OPTION_CHAIN"
      class="calculator-panel"
      style=" margin-right: 5px; margin-left: 5px;  padding: 0; border-bottom: 1px solid #8B93A6"
    >
      <span class="calculator-name">Options Calculator</span>

      <div
        style="margin-right: 150px; margin-top: 6px;"
        class="with-tip"
      >
        <a
          href="https://youtu.be/IP0MqazcVnY"
          target="_blank"
        >
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAACIklEQVRIidWVz2sTQRTHP7MbqQpeKkWjUaFHA/5AJclJT55ELdEcPHqSgggWFEHMBIr2oB56Kf0LxMVgvfQfUGoMlGoCOYqkNSlSDXixLc0+D0maTTObXb31Cwszs9/3/c5785iB3Q4VyHAcm0glhagEIkfbqytYFCmxgNbu/xnMTw+x3hhH5CFwyIe1iqgpXJkhozfDG+R1DJgDzg3anQclLK4xpr8FG+QnT8BWATgcUryDOk2SZHTV32B+eog/v4rAKYPAF1BvW0MZA04bOEttk+1yWT2/1xvjRnHFK4Y5TzqbI53NsRa9ALw2GJwlwh1zBo5jY1e+03+gW1iMIMQQ3rUSsK6yd0+NjY0fQGQHv06ZWKe7uhlEKimDOEADlwzwAhgFRrHc21x51AC+GvhR4iQ7E2+JkgYywAgwi3C5Pd+kac3hvNwHRI0RymxgJveiiahb3HzyHvu3Bg74GBwxGYTBU25k8+RzE8CDMAFdA1G1EPz9vNH3QZ4PZAnbWp4OUAWQIIOJELcXKBY6w24GZfcjsBoQ+qH9DUKNMsV+A61dRE0NCKxS5iLNk5eAZV+W8Mx7w/YesiszCJ99Qg9yxopjVeLAsA9nkZ/RWe9Cf0UdfRybAuHa1osadiTJ9cc92fW3aUZXaZIElv5BfBFI7BQ3G3hNFPeA+gDhOsJd1qIp0nrFRAhuOq0t4iSxVQJXjrW2pZZBFSi5n4KezN2Pvw7WpK5LkS4RAAAAAElFTkSuQmCC"/>
        </a>
        <span
          class="tip"
          style="text-align: center; padding: 5px; width: 140px;"
        >
        Watch tutorial
      </span>
      </div>

      <div
        class="chart-switcher"
        (click)="switchModeOptions()"
        [class.switcherDisabled]="this.regionIdOptions == 2 || this.regionIdOptions == 3 || this.regionIdOptions == 4"
      >
        <div
          [class.active]="isEODOptions"
          style="font-weight:normal; width: 36px ; font-size: 12px; text-align: center; padding-left: 5px"
        >EOD
        </div>
      </div>

      <iv-live-image-button
        (buttonClicked)="closeCalculatorWindow()"
      >
        <div class='square-content'>
          <div>
            <span
              class="material-icons"
              style="color: #8B93A6;"
            >&#xE5CD;</span>
          </div>
        </div>
      </iv-live-image-button>
    </div>

    <div style="border-right: 1px solid #8B93A6;"></div>

    <div
      class="calculator-panel"
      style="  margin-right: 5px; margin-left: 5px; padding: 0; border-bottom: 1px solid #8B93A6"
    >
      <span class="calculator-name">Probability Calculator</span>

      <div
        class="with-tip"
        style="margin-right: 130px; margin-top: 6px;"
      >
        <a
          statistic
          statisticElementName="Click watch calculator tutorial"
          href="https://youtu.be/IP0MqazcVnY"
          target="_blank"
        >
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAACIklEQVRIidWVz2sTQRTHP7MbqQpeKkWjUaFHA/5AJclJT55ELdEcPHqSgggWFEHMBIr2oB56Kf0LxMVgvfQfUGoMlGoCOYqkNSlSDXixLc0+D0maTTObXb31Cwszs9/3/c5785iB3Q4VyHAcm0glhagEIkfbqytYFCmxgNbu/xnMTw+x3hhH5CFwyIe1iqgpXJkhozfDG+R1DJgDzg3anQclLK4xpr8FG+QnT8BWATgcUryDOk2SZHTV32B+eog/v4rAKYPAF1BvW0MZA04bOEttk+1yWT2/1xvjRnHFK4Y5TzqbI53NsRa9ALw2GJwlwh1zBo5jY1e+03+gW1iMIMQQ3rUSsK6yd0+NjY0fQGQHv06ZWKe7uhlEKimDOEADlwzwAhgFRrHc21x51AC+GvhR4iQ7E2+JkgYywAgwi3C5Pd+kac3hvNwHRI0RymxgJveiiahb3HzyHvu3Bg74GBwxGYTBU25k8+RzE8CDMAFdA1G1EPz9vNH3QZ4PZAnbWp4OUAWQIIOJELcXKBY6w24GZfcjsBoQ+qH9DUKNMsV+A61dRE0NCKxS5iLNk5eAZV+W8Mx7w/YesiszCJ99Qg9yxopjVeLAsA9nkZ/RWe9Cf0UdfRybAuHa1osadiTJ9cc92fW3aUZXaZIElv5BfBFI7BQ3G3hNFPeA+gDhOsJd1qIp0nrFRAhuOq0t4iSxVQJXjrW2pZZBFSi5n4KezN2Pvw7WpK5LkS4RAAAAAElFTkSuQmCC"
          />
        </a>
        <span
          class="tip"
          style="text-align: center; padding: 5px; width: 140px;"
        >
        Watch tutorial
      </span>
      </div>

      <div
        (click)="switchModeProbability()"
        [class.switcherDisabled]="this.regionIdProbability == 2 || this.regionIdProbability == 3 || this.regionIdProbability == 4"
        class="chart-switcher"
      >
        <div
          *ngIf="isRt && this.regionIdProbability === 1 && tabType !== tabTypeEnum.FUTURES_OPTION_CHAIN"
          [class.active]="!isEODProbability"
          [class.disable]="this.regionIdProbability == 2 || this.regionIdProbability == 3 || this.regionIdProbability == 4"
          style="font-weight:normal; width: 36px; font-size: 12px"
        >RT
        </div>
        <div
          *ngIf="isDelayed && this.regionIdProbability === 1 && tabType !== tabTypeEnum.FUTURES_OPTION_CHAIN"
          [class.active]="!isEODProbability"
          [class.disable]="this.regionIdProbability == 2 || this.regionIdProbability == 3 || this.regionIdProbability == 4"
          style="font-weight:normal; width: 64px ; font-size: 12px;padding-left: 5px "
        >DELAYED
        </div>
        <div
          *ngIf="isRt && this.regionIdProbability !== 1 && tabType !== tabTypeEnum.FUTURES_OPTION_CHAIN"
          [class.active]="!isEODProbability"
          [class.disable]="this.regionIdProbability == 2 || this.regionIdProbability == 3 || this.regionIdProbability == 4"
          style="font-weight:normal; width: 36px; font-size: 12px"
          title="This mode is only available for the USA stocks"
        >RT
        </div>
        <div
          *ngIf="isDelayed && this.regionIdProbability !== 1 && tabType !== tabTypeEnum.FUTURES_OPTION_CHAIN"
          [class.active]="!isEODProbability"
          [class.disable]="this.regionIdProbability == 2 || this.regionIdProbability == 3 || this.regionIdProbability == 4"
          style="font-weight:normal; width: 64px ; font-size: 12px;padding-left: 5px "
          title="This mode is only available for the USA stocks"
        >DELAYED
        </div>
        <div
          [class.active]="isEODProbability"
          style="font-weight:normal; width: 36px ; font-size: 12px; text-align: center; padding-left: 5px"
        >EOD
        </div>
      </div>
      <iv-live-image-button
        (buttonClicked)="closeCalculatorWindow()"
        statistic
        statisticElementName="Click Option Monitor close calculator window"
      >
        <div class='square-content'>
          <div>
            <span
              class="material-icons"
              style="color: #8B93A6;"
            >&#xE5CD;</span>
          </div>
        </div>
      </iv-live-image-button>
    </div>

  </div>
  <div *dxTemplate="let data of 'content'">
    <div style="display: grid; grid-template-columns: 450px 450px; height: 100%;">
      <iv-live-options-calculator
        *ngIf="tabType === tabTypeEnum.OPTION_CHAIN && calculatorsPopupPopupVisible"
        (closeButtonClicked)="closeCalculatorWindow()"
        (returnRegionEvent)="returnRegionOptions($event)"
        (showMessageEvent)="showMessage($event)"
        [instrument]="selectedInstrument"
        [instruments]="instruments"
        [mode]="mode"
        (onInstrumentChange)="selectedInstrument = $event"
      ></iv-live-options-calculator>
      <iv-live-futures-calculator
        *ngIf="tabType === tabTypeEnum.FUTURES_OPTION_CHAIN && calculatorsPopupPopupVisible"
        [future]="selectedInstrument"
        [futures]="instruments"
        [mode]="mode"
        (closeButtonClicked)="closeCalculatorWindow()"
        (returnRegionEvent)="returnRegionOptions($event)"
        (showMessageEvent)="showMessage($event)"
        [currentTab]="currentTab"
        (onFutureChange)="selectedInstrument = $event"
      >
      </iv-live-futures-calculator>
      <iv-live-probability-calculator
        *ngIf="calculatorsPopupPopupVisible"
        (closeButtonClicked)="closeCalculatorWindow()"
        (returnRegionEvent)="returnRegionProbability($event)"
        (showMessageEvent)="showMessage($event)"
        [instrument]="selectedInstrument"
        [instruments]="instruments"
        [mode]="mode"
        [currentTab]="currentTab"
        (onInstrumentChange)="selectedInstrument = $event"
        style="border-left: 1px solid #A7A7A7;"
      ></iv-live-probability-calculator>
    </div>
  </div>
</dx-popup>

<dx-popup
  class="create-popup"
  [width]="500"
  [height]="! isError ? 500 : 230"
  [showTitle]="true"
  [showCloseButton]="false"
  [dragEnabled]="true"
  [closeOnOutsideClick]="true"
  [focusStateEnabled]="true"
  [(visible)]="popupCredit"
  [position]="{  my: 'center', at: 'center', of: 'iv-live-my-favorites'}"
  [shading]="false"
  titleTemplate="title"
>

  <div
    [style.backgroundColor]="themeColor === themeColorEnum.DARK ? '' : '#f1f2f7'"
    style="display: flex; padding: 0; border-bottom: none; height: 40px;"
    *dxTemplate="let data of 'title'"
  >

    <iv-live-credit *ngIf="popupCredit" [minus]="1" [isError]="isError" (cancel)="popupCredit=false" (proceed)="onDownloadClick()">
    </iv-live-credit>

  </div>

</dx-popup>

<dx-popup
  [(visible)]="volatilityTablePopupVisible"
  [closeOnOutsideClick]="true"
  [dragEnabled]="true"
  [shading]="false"
  [showCloseButton]="true"
  [showTitle]="true"
  [title]="'Volatility Table'"
  [width]="showIvx ? '280' : '160'"
  [height]="'auto'"
  class="volatility-table-popup"
>
  <div *dxTemplate="let data of 'content'">
    <div
      class="volatility-table-container"
      [style.justifyContent]="showIvx ? 'space-between' : 'center'"
    >

      <table
        class="ivx-table"
        *ngIf="showIvx"
      >
        <caption>IV Index</caption>
        <ng-container *ngIf="IVX && stockInfo">
          <tr *ngFor="let ivx of IVX">
            <td class="name">IVX{{ivx}}</td>
            <td class="value">{{stockInfo['ivx' + ivx]}}</td>
          </tr>
        </ng-container>
      </table>

      <table class="hv-table">
        <caption>Historical Vola</caption>
        <ng-container *ngIf="HV && stockInfo">
          <tr *ngFor="let hv of HV">
            <td class="name">HV{{hv}}</td>
            <td class="value">{{stockInfo['hv' + hv]}}</td>
          </tr>
        </ng-container>
      </table>

    </div>
  </div>
</dx-popup>
